export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11881.174b0108.jpg";